<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'FlotoDotSeparator',
  props: {
    color: {
      type: String,
      default: 'var(--neutral-light)',
    },
  },
}
</script>
